module.exports = __webpack_public_path__ + "img/mehmet-kirci.06a5742c.png";